module.exports = __webpack_public_path__ + "media/images/icons/banda_invitada_pink-4c69628e0ce4aa24bbf6a5d3bef17ea0.svg";